import { render, staticRenderFns } from "./Webshop.vue?vue&type=template&id=3d61250d"
import script from "./Webshop.vue?vue&type=script&lang=js"
export * from "./Webshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports